export const page8 = {
  "name": "page8",
  "title": "Physical Activity",
  "elements": [
    {
      "type": "rating",
      "name": "physical_activity",
      "title": "Do you engage in any physical activity on a regular basis?",
      "isRequired": true,
      "autoGenerate": false,
      "rateValues": [
        {
          "value": 1,
          "text": "Never"
        },
        {
          "value": 2,
          "text": "Rarely"
        },
        {
          "value": 3,
          "text": "Sometimes"
        },
        {
          "value": 4,
          "text": "Often"
        },
        {
          "value": 5,
          "text": "Very often"
        }
      ]
    },
    {
      "type": "rating",
      "name": "physical_activity_frequency",
      "title": "How often do you engage in physical activity?",
      "isRequired": true,
      "autoGenerate": false,
      "rateValues": [
        {
          "value": 1,
          "text": "Never"
        },
        {
          "value": 2,
          "text": "1–2x a week"
        },
        {
          "value": 3,
          "text": "3–4x a week"
        },
        {
          "value": 4,
          "text": "5–6x a week"
        },
        {
          "value": 5,
          "text": "Daily"
        }
      ]
    },
    {
      "type": "rating",
      "name": "moderate_activity",
      "title": "When engaging in physical activity, how much time do you spend on moderate activity?",
      "description": "Time spent in moderate activity in minutes during the week. Causes a slight but noticeable increase in breathing and heart rate. You can still talk, but not sing. Examples: brisk walking, light cycling, doubles tennis, water aerobics, gardening, or household chores done at a faster pace.",
      "isRequired": true,
      "rateValues": [
        { "value": "Item 1", "text": "<10 min" },
        { "value": "Item 2", "text": "20 min" },
        { "value": "Item 3", "text": "30 min" },
        { "value": "Item 4", "text": "40 min" },
        { "value": "Item 5", "text": "50+ min" }
      ]
    },
    {
      "type": "rating",
      "name": "intense_activity",
      "title": "When engaging in physical activity, how much time do you spend on moderate activity?",
      "description": "Time spent in intense activity in minutes during the week. Causes a substantial increase in breathing and heart rate. Talking becomes difficult; you can only say a few words without pausing for breath. Examples: running, jogging, fast cycling, swimming laps, singles tennis, HIIT workouts, or competitive sports.",
      "isRequired": true,
      "rateValues": [
        { "value": "Item 1", "text": "<10 min" },
        { "value": "Item 2", "text": "20 min" },
        { "value": "Item 3", "text": "30 min" },
        { "value": "Item 4", "text": "40 min" },
        { "value": "Item 5", "text": "50+ min" }
      ]
    },
    {
      "type": "rating",
      "name": "physical_activity_level",
      "title": "How would you rate your level of physical activity?",
      "rateType": "stars",
      "isRequired": true
    }
  ]
};